import classNames from "classnames";
import React from "react";
import type { BsPrefixProps, BsPrefixRefForwardingComponent } from "react-bootstrap/esm/helpers";
import { useBootstrapPrefix } from "./ThemeProvider";

export interface TimelineUi3Props extends BsPrefixProps, React.HTMLAttributes<HTMLElement> {}

export const TimelineUi3: BsPrefixRefForwardingComponent<"ul", TimelineUi3Props> = React.forwardRef<
	HTMLElement,
	TimelineUi3Props
>(({ as: Component = "ul", bsPrefix, className, ...props }, ref) => {
	bsPrefix = useBootstrapPrefix(bsPrefix, "ui3-timeline");

	return <Component ref={ref} className={classNames(className, bsPrefix)} {...props} />;
});
